// Social screens' copy in French (the Dutch in lib/social/copy.ts is the source), in our own words.
export const socialHubFr = {
  "social.about.section.account": "Compte",
  "social.about.sync.title": "Gardez vos notes avec vous",
  "social.about.sync.action": "Se connecter",
  "social.about.sync.manage": "Gérer",
  "social.about.sync.signedInAs": "Connecté en tant que {email}",
  "social.about.sync.unconfirmed":
    "Impossible de vérifier votre compte pour le moment ; vous restez connecté et nous réessaierons bientôt.",
  "social.signin.gate.title": "Connectez-vous pour déguster ensemble",
  "social.signin.gate.body":
    "Les amis, les groupes et les dégustations sont liés à un compte. Les notes de cet appareil restent à vous.",
  "social.signin.gate.action": "Se connecter",
  "social.about.public.label": "Joignable par les messages à « tout le monde »",
  "social.about.public.hint":
    "Activez cette option pour que des amis extérieurs à vos groupes puissent vous joindre par un message à « tout le monde » dans une dégustation. Elle décide seulement qui peut vous envoyer des messages, pas si l'on peut vous trouver dans la recherche : cela se règle sous « Les autres peuvent vous trouver ».",
  "social.about.discoverable.label": "Les autres peuvent vous trouver",
  "social.about.discoverable.hint":
    "Votre nom d'utilisateur et votre nom sont visibles dans la recherche des autres utilisateurs. Désactivez cette option pour ne pas être trouvé.",
  "social.signin.title": "Se connecter",
  "social.signin.subtitle": "Choisissez comment vous connecter",
  "social.signin.provider.google": "Google",
  "social.signin.provider.microsoft": "Microsoft",
  "social.signin.provider.instagram": "Instagram",
  "social.signin.provider.tiktok": "TikTok",
  "social.signin.provider.pending": "Pas encore disponible — en cours d'examen par le fournisseur",
  "social.signin.error.denied": "La connexion a été annulée ou refusée.",
  "social.signin.error.generic": "La connexion a échoué. Réessayez.",
  "social.signin.success.title": "Connecté",
  "social.friends.title": "Amis",
  "social.friends.empty.title": "pas encore d'amis",
  "social.friends.empty.body": "Ajoutez un ami pour déguster ensemble.",
  "social.friends.empty.action": "Ajouter en ami",
  "social.friends.incoming.title": "Demandes",
  "social.friends.incoming.accept": "Accepter",
  "social.friends.incoming.decline": "Refuser",
  "social.friends.outgoing.label": "Demande envoyée",
  "social.friends.outgoing.cancel": "Annuler la demande",
  "social.friends.row.block": "Bloquer",
  "social.friends.row.unblock": "Débloquer",
  "social.friends.row.remove": "Retirer",
  "social.friends.accepted.toast": "Vous êtes désormais amis",
  "social.friends.add.title": "Ajouter en ami",
  "social.friends.add.searchPlaceholder": "Nom ou nom d'utilisateur",
  "social.friends.add.send": "Envoyer la demande",
  "social.friends.add.queued": "Sera envoyée dès que vous serez de nouveau en ligne",
  "social.friends.add.sent": "Envoyée",
  "social.friends.add.noResults": "Aucun résultat",
  "social.friends.add.action": "Ajouter",
  "social.friends.search.resultCount": "{n} résultats",
  "social.groups.title": "Groupes",
  "social.groups.empty.title": "pas encore de groupes",
  "social.groups.empty.body": "Créez un groupe pour déguster ensemble.",
  "social.groups.empty.action": "Créer un groupe",
  "social.groups.memberCount": "{n} membres",
  "social.groups.role.owner": "propriétaire",
  "social.groups.role.admin": "administrateur",
  "social.groups.role.member": "membre",
  "social.groups.create.title": "Créer un groupe",
  "social.groups.create.name": "Nom",
  "social.groups.create.description": "Description (facultatif)",
  "social.groups.create.confirm": "Créer",
  "social.groups.edit.title": "Modifier le groupe",
  "social.groups.edit.confirm": "Enregistrer",
  "social.groups.avatar.upload": "Choisir une photo",
  "social.groups.avatar.uploading": "Envoi en cours…",
  "social.groups.avatar.remove": "Supprimer la photo",
  "social.groups.visibility.label": "Qui peut voir ce groupe",
  "social.groups.visibility.membersAndInvitees": "Visible des membres et des invités",
  "social.groups.visibility.membersOnly": "Membres uniquement, sans aperçu du lien",
  "social.groups.visibility.discoverable": "Visible dans l'annuaire des groupes",
  "social.groups.directory.entry": "Trouver un groupe",
  "social.groups.directory.title": "Trouver un groupe",
  "social.groups.directory.searchPlaceholder": "Nom du groupe",
  "social.groups.directory.noResults": "Aucun groupe trouvé",
  "social.groups.directory.resultCount": "{n} résultats",
  "social.groups.directory.requestToJoin": "Demander à rejoindre",
  "social.groups.directory.requested": "Demandé",
  "social.groups.joinRequests.title": "Demandes d'adhésion",
  "social.groups.joinRequests.accept": "Accepter",
  "social.groups.joinRequests.decline": "Refuser",
  "social.groups.invitePermission.label": "Qui peut inviter",
  "social.groups.invitePermission.ownerAdmin": "Uniquement le propriétaire et les administrateurs",
  "social.groups.invitePermission.anyMember": "Tous les membres",
  "social.groups.detail.editAction": "Modifier le groupe",
  "social.groups.detail.removeMember": "Retirer",
  "social.groups.detail.leave": "Quitter le groupe",
  "social.groups.detail.delete": "Supprimer le groupe",
  "social.groups.detail.loadMore": "Afficher plus",
  "social.groups.detail.zeroOwnerLeaveBlocked":
    "Transférez d'abord la propriété, ou supprimez le groupe",
  "social.groups.invite.title": "Inviter",
  "social.groups.invite.noFriends": "Aucun ami à inviter.",
  "social.session.title": "Dégustation",
  "social.session.draft.nameLabel": "Nom",
  "social.session.draft.invite": "Inviter",
  "social.session.draft.startNow": "Démarrer maintenant",
  "social.session.scheduled.label": "Prévue le {date}",
  "social.session.action.schedule": "Planifier",
  "social.session.action.start": "Démarrer",
  "social.session.action.cancel": "Annuler",
  "social.session.action.end": "Terminer",
  "social.session.status.invited": "invité",
  "social.session.status.joined": "a rejoint",
  "social.session.status.online": "en ligne",
  "social.session.status.offline": "hors ligne",
  "social.session.status.live": "En direct",
  "social.session.ended.title": "Terminée",
  "social.session.ended.toast": "cette dégustation est terminée",
  "social.session.reconnecting": "Reconnexion…",
  "social.session.presenceCount": "{n} en ligne",
  "social.session.schedule.date": "Date (facultatif)",
  "social.session.schedule.time": "Heure (facultatif)",
  "social.session.schedule.invalid": "Choisissez une date et une heure à venir.",
  "social.session.invite.title": "Inviter des participants",
  "social.session.invite.confirm": "Inviter",
  "social.session.invite.sourceFriends": "Amis",
  "social.session.invite.sourceGroup": "Groupe",
  "social.broadcast.composer.title": "Envoyer un message",
  "social.broadcast.composer.targetFriends": "Amis",
  "social.broadcast.composer.targetGroup": "Groupe",
  "social.broadcast.composer.targetEveryone": "Tous les participants de cette dégustation",
  "social.broadcast.composer.textPlaceholder": "Votre message…",
  "social.broadcast.composer.send": "Envoyer",
  "social.broadcast.composer.queued": "Sera envoyé dès que vous serez de nouveau en ligne",
  "social.broadcast.composer.sent": "Envoyé",
  "social.broadcast.composer.sentPartial": "Envoyé, {n} non remis",
  "social.broadcast.panel.title": "Adressé à vous dans cette dégustation",
  "social.broadcast.panel.empty": "Rien ne vous est encore adressé dans cette dégustation",
  "social.presence.online": "en ligne",
  "social.presence.offline": "hors ligne",
  "social.invite.friends.action": "Inviter",
  "social.invite.friends.title": "Inviter des amis",
  "social.invite.friends.lead":
    "Envoyez votre lien personnel. Quiconque l'ouvre et se connecte devient votre ami.",
  "social.invite.group.title": "Inviter dans {group}",
  "social.invite.group.lead": "Quiconque ouvre le lien ou saisit le code rejoint le groupe.",
  "social.invite.channel.whatsapp": "WhatsApp",
  "social.invite.channel.email": "E-mail",
  "social.invite.channel.sms": "SMS",
  "social.invite.channel.copy": "Copier le lien",
  "social.invite.channel.copied": "Lien copié",
  "social.invite.qr.label": "QR code de l'invitation",
  "social.invite.code.label": "Ou donnez ce code",
  "social.invite.code.until": "Valable jusqu'à {time}",
  "social.invite.status": "Encore {left} utilisation(s) sur {max}, valable jusqu'au {date}",
  "social.invite.audience.one": "Une personne",
  "social.invite.audience.many": "Jusqu'à 10 personnes",
  "social.invite.audience.manyHint": "À partir de deux personnes, vous confirmez chaque demande.",
  "social.invite.approval.label": "Approuver d'abord les nouveaux membres",
  "social.invite.joined.title": "Qui a rejoint",
  "social.invite.revoke": "Révoquer le lien",
  "social.invite.revoked": "Ce lien ne fonctionne plus.",
  "social.invite.renew": "Créer un nouveau lien",
  "social.invite.landing.title": "Invitation",
  "social.invite.landing.friend": "{name} vous invite à déguster ensemble.",
  "social.invite.landing.group": "{name} vous invite dans {group}.",
  "social.invite.landing.groupHidden": "{name} vous invite dans un groupe.",
  "social.invite.landing.approval": "Un administrateur approuve votre demande.",
  "social.invite.landing.expires": "Valable jusqu'au {date}",
  "social.invite.landing.accept": "Accepter",
  "social.invite.landing.decline": "Non, merci",
  "social.invite.landing.signIn": "Se connecter pour accepter",
  "social.invite.landing.gone.title": "Cette invitation ne fonctionne plus",
  "social.invite.landing.gone.body": "Demandez un nouveau lien ou un nouveau code.",
  "social.invite.landing.none.title": "Aucune invitation trouvée",
  "social.invite.landing.none.body": "Rouvrez le lien, ou saisissez le code.",
  "social.invite.outcome.friends": "Vous êtes désormais amis",
  "social.invite.outcome.requested": "Demande envoyée. {name} la confirmera.",
  "social.invite.outcome.joined": "Vous êtes membre du groupe",
  "social.invite.outcome.joinRequested": "Demande envoyée. Un administrateur l'approuvera.",
  "social.invite.outcome.toFriends": "Aller aux amis",
  "social.invite.outcome.toGroup": "Aller au groupe",
  "social.code.action": "Vous avez un code ?",
  "social.code.title": "Saisir un code",
  "social.code.hint": "Trois mots pour une invitation, six pour une dégustation.",
  "social.code.placeholder": "p. ex. leaf lime loft",
  "social.code.submit": "Continuer",
  "social.code.invalid": "Ce n'est pas un code. Vérifiez les mots.",
  "social.samen.title": "Ensemble",
  "social.samen.badge": "{label}, {count} nouveau(x)",
  "social.samen.announce": "{count} nouveau(x) dans Ensemble",
  "social.samen.profile": "Votre profil",
  "social.samen.lead": "Vos amis, vos groupes et ce qui vous attend.",
  "social.inbox.title": "Boîte de réception",
  "social.inbox.tab.received": "Reçus",
  "social.inbox.tab.sent": "Envoyés",
  "social.inbox.tab.updates": "Actualités",
  "social.inbox.empty.received": "Rien ne vous attend.",
  "social.inbox.empty.sent": "Vous n'attendez personne.",
  "social.inbox.empty.updates": "Pas encore de nouvelles.",
  "social.inbox.friendRequest": "veut devenir votre ami",
  "social.inbox.groupInvite": "{name} vous invite dans {group}",
  "social.inbox.groupInviteAnonymous": "Invitation dans {group}",
  "social.inbox.joinRequest": "veut rejoindre {group}",
  "social.inbox.sessionInvite": "{name} vous invite à {session}",
  "social.inbox.accept": "Accepter",
  "social.inbox.decline": "Refuser",
  "social.inbox.open": "Voir",
  "social.inbox.cancel": "Retirer",
  "social.inbox.remind": "Relancer",
  "social.inbox.reminded": "Relancé",
  "social.inbox.sent.friendRequest": "Demande d'ami",
  "social.inbox.sent.groupInvite": "Invité dans {group}",
  "social.inbox.links.title": "Vos liens",
  "social.inbox.link.friend": "Lien personnel",
  "social.inbox.link.group": "Lien pour {group}",
  "social.inbox.link.ended": "Ne fonctionne plus",
  "social.inbox.link.joined": "Ont rejoint : {names}",
  "social.inbox.update.friendAccepted": "{name} est désormais votre ami",
  "social.inbox.update.groupInviteAccepted": "{name} a rejoint {group}",
  "social.inbox.update.joinApproved": "Vous avez été admis dans {group}",
  "social.inbox.someone": "Quelqu'un",
  "social.inbox.aGroup": "un groupe",
  "social.inbox.queued": "Sera traité dès que vous serez de nouveau en ligne",
  "social.profile.title": "Profil",
  "social.profile.lead": "Voici comment les autres vous voient.",
  "social.profile.noGroups": "Vous n'êtes encore dans aucun groupe.",
  "social.profile.signedOut": "Connectez-vous pour avoir un profil que vos amis peuvent voir.",
  "social.settings.title": "Réglages",
  "social.settings.open": "Ouvrir les réglages",
  "social.notify.title": "Notifications",
  "social.notify.invites": "Invitations et demandes",
  "social.notify.invites.hint":
    "Une notification quand quelqu'un vous invite ou veut devenir votre ami. Qui a accepté apparaît dans votre boîte de réception.",
  "social.notify.quiet": "Heures calmes",
  "social.notify.quiet.from": "De",
  "social.notify.quiet.until": "À",
  "social.notify.quiet.hint":
    "Pas de notifications pendant ces heures ; tout reste dans votre boîte de réception. {n} notifications par jour au maximum.",
  "social.notify.mutes.title": "En sourdine",
  "social.notify.mutes.empty":
    "Personne en sourdine. Un ami ou un groupe mis en sourdine ne vous envoie plus de notifications.",
  "social.notify.mute": "Mettre en sourdine",
  "social.notify.unmute": "Réactiver les notifications",
  "social.groups.inviteFriends": "Inviter des amis",
  "social.groups.inviteFriends.sent":
    "{n} invité(s). Ils rejoignent le groupe dès qu'ils acceptent.",
  "social.groups.inviteLink": "Partager un lien",
  "social.groups.log.title": "Journal",
  "social.groups.log.empty": "Rien ne s'est encore passé.",
  "social.groups.log.created": "{name} a créé le groupe",
  "social.groups.log.joined": "{name} a rejoint le groupe",
  "social.groups.log.left": "{name} a quitté le groupe",
  "social.groups.log.removed": "{name} a été retiré du groupe",
  "social.groups.log.role": "{name} est désormais {role}",
  "social.groups.mute": "Mettre le groupe en sourdine",
  "social.groups.unmute": "Réactiver les notifications du groupe",
  "social.share.title": "Partager",
  "social.share.action": "Partager",
  "social.share.shared": "Partagé",
  "social.share.copied": "Lien copié",
  "social.invite.channel.share": "Partager…",
  "social.inbox.link.reshare": "Partager à nouveau",
} as const;
